// lib
import { useState, useCallback, useEffect } from 'react'

import {
  TableDataView,
  TableDataViewCol,
  TableDataViewRow
} from '@aytm/app/stats/page/question-views/components/table/types'

import TableHeader from '@aytm/app/stats/page/question-views/components/table/TableHeader'
import TableRow from '@aytm/app/stats/page/question-views/components/table/TableRow'

// styles
import style from '@aytm/app/stats/page/question-views/components/table/styles/Table.module.scss'

export default function Table(table: TableDataView) {
  const [cols, setCols] = useState(table.cols)
  const [rows, setRows] = useState(table.rows)

  const onSortHandler = useCallback(
    (colIndex: number, dir: 1 | -1) => {
      if ('onSort' in table && 'function' == typeof table.onSort) {
        return table.onSort(colIndex, dir)
      } else {
        const removeSorted = (items: TableDataViewCol[]) =>
          items.map(item => {
            delete item.sorted
            if ('cols' in item) {
              item.cols = removeSorted(item.cols)
            }
            return item
          })
        const applySorted = (items: TableDataViewCol[], index: number) => {
          if (colIndex < index + items.length) {
            items[colIndex - index].sorted = dir
          } else {
            let prevColsLength = 0
            return items.map(item => {
              if ('cols' in item) {
                item.cols = applySorted(item.cols, items.length + prevColsLength)
                prevColsLength += item.cols.length
              } else prevColsLength += 1
              return item
            })
          }
          return items
        }

        const newCols = applySorted(removeSorted(table.cols), 0)
        return setCols(newCols)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [table.cols, table.onSort]
  )

  useEffect(() => setCols(table.cols), [table.cols])
  useEffect(() => {
    let newRows = table.rows

    const getColSorted = (items: TableDataViewCol[]) => {
      const item = items.find(v => 'sorted' in v)
      if (!item) {
        const _items = items.flatMap(item => ('cols' in item ? item.cols : []))
        if (0 < _items.length) return getColSorted(_items)
      }
      return item
    }

    const colSorted = getColSorted(cols)
    if (colSorted != undefined && 'sort' in colSorted) {
      newRows = newRows
        .sort((a: TableDataView['rows'][number], b: TableDataView['rows'][number]) =>
          colSorted.sort(a, b, colSorted.sorted)
        )
        .slice()
    }

    setRows(newRows)
  }, [table.rows, cols])

  return (
    <div
      className={`${style.component}${
        'classNames' in table ? ` ${table.classNames.map(className => style[className]).join(' ')}` : ''
      }`}
    >
      <TableHeader index={0} cols={cols} onSort={onSortHandler} />
      {rows.map((row: TableDataViewRow) => (
        <TableRow key={`table-row-${row.position}`} cols={cols} row={row} />
      ))}
    </div>
  )
}
